




























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { combineLatest } from 'rxjs';
import * as service from '@/services/parameters';
import { SCHEDULING_DAYS } from '@/settings/consts/parameters-keys';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiReferencesTypesHierarchy from '@/components/UI/references-types-hierarchy/index.vue';
import ParametersEditModal from '@/components/parameters/edit-modal.vue';
import ParameterModel from '@/models/parameter-model';
import { REFERENCE_TYPE_EMEDE } from '@/settings/consts/rules-engine';
import {
  MESSAGE_PARAMETER_ERROR,
  MESSAGE_PARAMETER_DUPLICATE,
} from '@/settings/consts/messages';
import { ERROR_CODE_DUPLICATE } from '@/settings/consts/api-error';
import { errorHandling } from '@/helpers/errorHandling';

@Component({
  components: {
    PermissionAuth,
    UiReferencesTypesHierarchy,
    ParametersEditModal,
  },
})
export default class ParametersFormSchedulingDays extends BaseComponent {
  @Prop()
  public editItem: any;
  @Prop()
  public modalOpen: boolean;

  public item: ParameterModel = new ParameterModel();

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.item = new ParameterModel();

    if (!val) {
      return;
    }

    this.item = new ParameterModel(this.editItem);
  }

  public beforeMount(): void {
    this.onEditItemChanges(this.editItem);
  }

  public onClose(): void {
    this.$emit('close');
  }
}
